export default "__VITE_ASSET__f6678378__"